import "./cloudy.mcss";

// by importing this, it sets itself up fully
import "@crate/singleton/nav_stack.mts";

import { BuxDocument } from "./mod.mts";

// TODO: if you need additional functionality, just extend it

export class BuxDocumentCloudy extends BuxDocument {}
